module.exports = __webpack_public_path__ + "static/img/zhong.6d55f6d5.png";